const wrapper = document.querySelector('[section-stores-list]');
if (!wrapper) return;

const storeGrid = document.querySelector('.store__grid');
const searchInput = document.querySelector('#search');
const storeNotFoundEl = document.querySelector('.store__grid--not-found');

if (!storeGrid || !searchInput) {
	return;
}

let allStores;
let currentSeachVal;

init();

async function init() {
	renderStoreItems(await findAllStores());
	addEventListeners();
}

async function findAllStores() {

	function csvToArray(csv) {
		const lines = csv.split('\n');
		const headers = lines[0].split(',');
		return lines.slice(1).map(line => {
			const values = line.split(',');
			return headers.reduce((obj, header, index) => {
				obj[header] = values[index];
				return obj;
			}, {});
		});
	}

	const csvUrl = wrapper.getAttribute('data-stores-list-url');
	const csv = await fetch(csvUrl);

	if (!csv) {
		console.error('Error fetching CSV:', error);
		failToRender = true;
		storeGrid.innerHTML = 'Fail to render stores';
		return;
	}

	const csvData = await csv.text();
	allStores = csvToArray(csvData);
	return allStores;
}

function storesNotFound(storeNotFound) {
	if (!storeNotFoundEl) return;
	if (storeNotFound) {
		storeNotFoundEl.classList.remove('d-none');
		const searchTerm = storeNotFoundEl.querySelector('[search-term]');
		if (!searchTerm) return;
		searchTerm.innerText = currentSeachVal;
	}
	else storeNotFoundEl.classList.add('d-none')
}

function renderStoreItems(results) {
	if (currentSeachVal === undefined || currentSeachVal.length === 0) {
		storeGrid.classList.add('d-none');
	}
	else {
		if (storeGrid.classList.contains('d-none')) storeGrid.classList.remove('d-none');
	}
	if (results.length === 0) storesNotFound(true);
	else storesNotFound(false);
	const storeItemTemplate = wrapper.querySelector('template.store__grid--item-template').content;
	if (!storeItemTemplate) return;

	storeGrid.innerHTML = '';
	results.map(function (store) {
		const storeItem = storeItemTemplate.cloneNode(true);
		storeItem.querySelector('.store__item--title').innerText = store.Name;
		const storeItemAddress = storeItem.querySelector('.store__item--address');
		storeItemAddress.innerHTML = `${store.Address?.trim()} <br> ${store["Postal code"]} ${store.City}`;

		if (store.Website.includes('https://')) {
			storeItem.querySelector('.store__item--web-url').setAttribute('href', store.Website);
			const webSiteName = store.Website.replace(/^https:\/\//, '');
			storeItem.querySelector('.store__item--web-url').innerText = webSiteName;
		}

		if (store.Address != '') {
			storeItem.querySelector('.store__item--map-url').setAttribute('href', `https://www.google.com/maps?q=${store.Address} + ${store.City || ''} + ${store['Postal code'] || ''}`);
			storeItem.querySelector('.store__item--map-url').classList.remove('d-none');
		}

		storeGrid.append(storeItem)
	})
}

function addEventListeners() {
	let searchValue = searchInput.value;

	searchInput.addEventListener('input', function (event) {
		if (event.target.value.length < 3) {
			searchValue = '';
			currentSeachVal = '';
		} else {
			currentSeachVal = event.target.value;
			searchValue = event.target.value.toLowerCase();
		}
		utilizeSearch(searchValue);
	});
}

function utilizeSearch(searchValue) {
	const searchedStores = searchStores(searchValue, allStores);

	renderStoreItems(searchedStores);
}

function searchStores(searchValue, filteredStores) {
	let searchedStores = [];
	const lowerSearch = searchValue.toLowerCase();

	filteredStores.forEach(store => {
		if (!store) return;

		const storeAddress = store?.Adress;
		const storeCity = store?.City;
		const storeName = store?.Name;
		const storePostalCode = store['Postal code'];

		if (
			(storeAddress && storeAddress.toLowerCase().includes(lowerSearch)) ||
			(storeCity && storeCity.toLowerCase().includes(lowerSearch)) ||
			(storeName && storeName.toLowerCase().includes(lowerSearch)) ||
			(storePostalCode && storePostalCode.toLowerCase().includes(lowerSearch))
		) {
			searchedStores.push(store);
		}
	});
	return searchedStores;
}

